import type { PrescriptionAssistantSliceType } from '../types';

export const isPrescriptionInProgress = (get: () => PrescriptionAssistantSliceType) => {
  const state = get();

  const {
    prescriptionPad: { medicationPadItems },
    prescriptionHistory: { itemsToCancel, itemsToReissue }
  } = state.prescriptionAssistant;

  const validPrescriptionMedications = medicationPadItems.filter((item) => !!item.medicationPadItem);

  return validPrescriptionMedications.length > 0 || itemsToCancel.length > 0 || itemsToReissue.length > 0;
};
